module.exports = __webpack_public_path__ + "static/media/tuesday-collective-default.a2577dba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tuesday-collective-default.jpg
// module id = 151
// module chunks = 0